import cn from 'classnames';
import React from 'react';
import './DSSpinner.scss';

export const DSSpinner = (props: React.HTMLAttributes<SVGElement>) => {
	return (
		<svg className={cn('spinner', props.className)} viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
			{/* stroke width slightly less than 8 to prevent artifacts on the edge of the spinner and the background */}
			<circle cx="28" cy="28" r="24" stroke="white" strokeWidth="7.5" fill="none" />
			<path
				d="M52 28C52 31.1517 51.3792 34.2726 50.1731 37.1844C48.967 40.0962 47.1992 42.742 44.9706 44.9706C42.742 47.1992 40.0962 48.967 37.1844 50.1731C34.2726 51.3792 31.1517 52 28 52C24.8483 52 21.7274 51.3792 18.8156 50.1731C15.9038 48.967 13.258 47.1992 11.0294 44.9706C8.80083 42.742 7.033 40.0962 5.82689 37.1844C4.62078 34.2726 4 31.1517 4 28"
				stroke="currentColor"
				strokeWidth="8"
				strokeLinecap="round"
			/>
		</svg>
	);
};
